import { useState, useEffect } from 'react';
import { ProductCard } from './ProductCard';

const API_URL = window.location.hostname === 'localhost'
  ? 'http://localhost:5000'
  : 'https://kiyafet-magazasi-backend.vercel.app';

interface Product {
  id: number;
  ad: string;
  fiyat: number;
  eskiFiyat?: number;
  kategori: string;
  resimler?: string[];
  stokDurumu?: boolean;
  stokMiktari?: number;
}

interface ProductSectionProps {
  activeCategory?: string;
}

export function ProductSection({ activeCategory = 'all' }: ProductSectionProps) {
  const [selectedCategory, setSelectedCategory] = useState(activeCategory);
  const [products, setProducts] = useState<Product[]>([]);
  const [categories, setCategories] = useState<{id: string, name: string}[]>([]);

  useEffect(() => {
    // Ürünleri backend'den çek
    fetch(`${API_URL}/api/urunler`)
      .then(res => res.json())
      .then(data => { if (Array.isArray(data)) setProducts(data); })
      .catch(err => console.error('Ürünler yüklenemedi:', err));

    // Kategorileri backend'den çek
    fetch(`${API_URL}/api/kategoriler`)
      .then(res => res.json())
      .then(data => {
        if (Array.isArray(data)) {
          const cats = data.filter((k: any) => k.aktif !== false && k.ad !== 'Tümü').map((k: any) => ({ id: k.ad, name: k.ad }));
          setCategories(cats);
        }
      })
      .catch(err => console.error('Kategoriler yüklenemedi:', err));
  }, []);

  useEffect(() => {
    setSelectedCategory(activeCategory);
  }, [activeCategory]);

  const filteredProducts = selectedCategory === 'all'
    ? products
    : products.filter(p => p.kategori === selectedCategory);

  return (
    <section className="max-w-7xl mx-auto px-4 py-16">
      {/* Category Tabs */}
      <div className="flex items-center gap-2 mb-8 overflow-x-auto pb-2 scrollbar-hide">
        {categories.map((cat) => (
          <button
            key={cat.id}
            onClick={() => setSelectedCategory(cat.id)}
            className={`px-6 py-2 rounded-full font-medium transition-colors whitespace-nowrap ${
              selectedCategory === cat.id
                ? 'bg-pink-500 text-white'
                : 'text-gray-700 hover:bg-gray-100'
            }`}
          >
            {cat.name}
          </button>
        ))}
      </div>

      {/* Products Grid */}
      <div className="flex items-center justify-between mb-4">
        <p className="text-sm text-gray-500">{filteredProducts.length} ürün</p>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
        {filteredProducts.map((product) => {
          const resimUrl = product.resimler?.[0] || 'https://via.placeholder.com/400x533?text=Resim+Yok';
          const resimUrl2 = product.resimler?.[1] || undefined;
          const fiyat = parseFloat(String(product.fiyat)) || 0;
          const eskiFiyat = product.eskiFiyat ? parseFloat(String(product.eskiFiyat)) : undefined;
          // eskiFiyat > fiyat ise indirim var (eskiFiyat orijinal, fiyat indirimli)
          const indirimVar = eskiFiyat !== undefined && eskiFiyat > fiyat;
          const badge = indirimVar ? `%${Math.round((1 - fiyat / eskiFiyat!) * 100)} İndirim` : undefined;
          const outOfStock = product.stokDurumu === false || product.stokMiktari === 0;
          return (
            <ProductCard
              key={product.id}
              id={product.id}
              name={product.ad}
              price={`${fiyat.toLocaleString('tr-TR')} TL`}
              oldPrice={indirimVar ? `${eskiFiyat!.toLocaleString('tr-TR')} TL` : undefined}
              image={resimUrl}
              image2={resimUrl2}
              badge={badge}
              outOfStock={outOfStock}
            />
          );
        })}
      </div>

      {filteredProducts.length === 0 && (
        <div className="text-center py-16 text-gray-500">
          <p className="text-xl">Bu kategoride ürün bulunamadı</p>
        </div>
      )}
    </section>
  );
}
